import React from 'react'

import { LoaderIcon } from 'core-components/library/loader'

import { PartnerPreview } from './partnerIdForm/partnerOverview/PartnerPreview'

interface IProps {
  PartnerID: string
}

export const PartnerIdForm = (props: IProps) => {
  return (
    <div>
      <PartnerPreview widgetParams={{}} PartnerId={props.PartnerID} editable />
    </div>
  )
}

const PartnerIdFormComponent = React.lazy(() =>
  import('./PartnerIdForm').then((m) => ({
    default: m.PartnerIdForm,
  }))
)

export const LazyPartnerIdFormComponent: React.FunctionComponent<IProps> = (props: IProps) => (
  <React.Suspense fallback={<LoaderIcon />}>
    <PartnerIdFormComponent {...props} />
  </React.Suspense>
)
